import { StatusBar, Style } from '@capacitor/status-bar';
import { canSetupNativePlugin } from '@/utils';

/** 状态栏沉浸 */
export default async function setupStatusBar() {
  const canSetupPlugin = canSetupNativePlugin();
  if (canSetupPlugin) {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#00000000' }); // 全透明
    // 关键：设置状态栏透明，允许内容延伸
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.hide();
  }
}
